<script setup lang="ts">
import { UseImage } from '@vueuse/components'
import capitalize from '@/lib/capitalize'
import DeepdiveLink from '../utils/DeepdiveLink.vue'
import getDeepdiveUrl from '@/lib/getDeepdiveUrl'
import type { UserConfig } from '@/lib/interfaces/calculator'

const userConfigExchange = defineModel<UserConfig['exchange']>({ required: true }) 

</script>

<template>
  <div>
    <div class="flex justify-between items-center">
      <span class="font-semibold">
        Exchange
      </span>
      <DeepdiveLink label="Why" :href="getDeepdiveUrl('details/calculator/why-exchange')" />
    </div>
    <a 
      :href="getDeepdiveUrl('supported-exchanges')" 
      :class="[
        'w-full px-4 py-3 mt-2.5 bg-brand-background flex justify-between',
        'border-2 border-brand-primary rounded-3'
      ]"
    >
      <div class="flex items-center gap-x-2.5" >
        <UseImage 
          class="w-4 h-4" 
          :src="`/exchanges/icons/${userConfigExchange}.svg`"
          :alt="userConfigExchange"
        >
          <template #error>
            <div class="bg-white rounded-full w-4 h-4 opacity-20" />
          </template>
        </UseImage>
        <span class="text-base sm:text-sm font-semibold">{{ capitalize(userConfigExchange) }}</span>
      </div>
      <span class="sr-only" >
        {{ $t('click_to_open_deepdive') }}
      </span>
    </a>
  </div>
</template>